import techInsightsPlugin from '@backstage-community/plugin-tech-insights/alpha';
import {
  coreExtensionData,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { Box, Typography } from '@material-ui/core';

export const scorecardsRouteRef = createRouteRef();

export const scorecardDataDescription =
  'Missing checks mean data is unavailable or awaiting collection. Has License means a recognized SPDX license.';

// Keep the stock scorecard renderer and make omitted facts explicit to readers.
export const gcpTechInsightsPlugin = techInsightsPlugin.withOverrides({
  extensions: [
    // The retained plugin page has no route ref, so it is excluded from nav.
    techInsightsPlugin.getExtension('page:tech-insights').override({
      params: { routeRef: scorecardsRouteRef },
    }),
    techInsightsPlugin
      .getExtension('entity-card:tech-insights/scorecards')
      .override({
        *factory(originalFactory) {
          // Preserve the native frontend loader. The package-root card export
          // is a legacy routable extension and cannot be nested here.
          for (const data of originalFactory()) {
            if (data.id === coreExtensionData.reactElement.id) {
              yield coreExtensionData.reactElement(
                <Box>
                  <Typography variant="body2" paragraph>
                    {scorecardDataDescription}
                  </Typography>
                  {data.value}
                </Box>,
              );
            } else {
              yield data;
            }
          }
        },
      }),
  ],
});
